import React, { useCallback } from 'react';
import { Button, Grid, Paper } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import TopBarActions from './TopBarActions';
import EditableAudioFileName from './controls/EditableAudioFileName';
import { useNavigate } from 'react-router';

const styles = theme => ({
    fileControlsContainer: {
        height: theme.spacing(8),
        top: 0,
        left: 0,
        right: 0,
        position: 'relative',
        borderBottom: theme.palette.type === 'light' ? '1px solid rgba(0, 0, 0, 0.12)' : '1px solid rgba(255, 255, 255, 0.12)',
        padding: '0 ' + theme.spacing(2).toString(),
    },
    buttonContainerGrid: {
        height: '100%',
        marginTop: 0,
        flexWrap: 'nowrap'
    },
    fileControlsItem: {
        flex: '0 0 auto'
    },
    titleTextContainer: {
        flex: '0 1 auto',
        minWidth: 0,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }
});

const TopBar = ({ classes }) => {
    const navigate = useNavigate();

    const onVideosClick = useCallback(() => {
        navigate('/videos');
    }, [navigate]);

    return (
        <Paper
            className={classes.fileControlsContainer}
            square
            elevation={0}
        >
            <Grid
                container
                direction='row'
                alignItems='center'
                className={classes.buttonContainerGrid}
            >
                <Grid className={classes.fileControlsItem}>
                    <Button
                        startIcon={<ArrowBackIosIcon />}
                        onClick={onVideosClick}
                        variant='text'
                    >
                        Videos
                    </Button>
                </Grid>
                <Grid className={classes.titleTextContainer}>
                    <EditableAudioFileName />
                </Grid>
                <Grid style={{ flexGrow: 1 }} />

                {/* Render the actions on top panel */}
                <Grid
                    style={{ height: '100%' }}
                    className={classes.fileControlsItem}
                    id='file-controls-container'
                >
                    <TopBarActions />
                </Grid>
            </Grid>
        </Paper>
    );
}

export default withStyles(TopBar, styles);
